import React from 'react';

export default function StatusBadge({ status }) {
  return <span className={`j-chip ${status}`}>{status}</span>;
}
